import DataLakeReportChart from '@/components/charts/data-lake-report-chart/data-lake-report-chart';
import { OverallToolListModel } from '@/models/data-lake/data-lake';
import { dataLakeAPI } from '@/providers/apis/data-lake/data-lake';
import moment from 'moment';
import { Vue, Component, Prop } from 'vue-property-decorator';
import DateRangePicker from 'vue2-daterange-picker';
import ReportDetailedPullup from '../report-detailed-pullup/report-detailed-pullup';

@Component({
    name: 'data-lake-reports',
    components: {
        'report-chart': DataLakeReportChart,
        'date-range-picker': DateRangePicker,
        'report-details': ReportDetailedPullup,
    },
})

export default class DataLakeReports  extends Vue {

    // -----------------------------------------------------
    // Properties

    @Prop()
    private dateRange!: {startDate: string, endDate: string};

    private contentProviders: OverallToolListModel[] = [];

    private studentChartLabel: any = {
        xAxis: 'Content Providers',
        yAxis: 'Students',
    };

    private activitiesChartLabel: any = {
        xAxis: 'Content Providers',
        yAxis: '# of Activities',
    };

    private activeProvider: OverallToolListModel = {} as OverallToolListModel;

    private dropdownOptions: any = [
        {
            name: 'By Student',
            key: 'student',
            route: '/data-lake-report/activities',
        },
        {
            name: 'By Vendor',
            key: 'vendor',
            route: '/data-lake-report/student-summary',
        },
    ];

    private activityOptions: any = [
        {
            name: 'By Student',
            key: 'student',
            route: '/data-lake-report/student-access-activity',
        },
        {
            name: 'By Vendor',
            key: 'vendor',
            route: '/data-lake-report/student-summary',
        },
    ];

    // -------------------------------------------------------------
    // Hooks

    private created() {
        this.loadToolData();
    }

    // -------------------------------------------------------------
    // Actions

    private onChangeDateRange() {
        this.$emit('onChangeDateRange', this.dateRange);
    }

    private onSelectOptions(option: any) {
        this.$router.push({
            path: option.route,
        });
    }

    private onSelectProvider(provider: any) {
        (this.$refs['data-lake-pullup'] as any).toggle();
    }

    private onSelectActivity(provider: any) {
        (this.$refs['data-lake-pullup'] as any).toggle();
    }

    // -------------------------------------------------------------
    // Methods

    private loadToolData() {
        const params = this.dateRange;
        dataLakeAPI.fetchListOfTools(params).then((toolList) => {
            this.contentProviders = toolList;
        });
    }

}
